<template>
  <div>
    <v-card style="width:100%;padding:10px;">
      <v-layout row wrap style="height:40px;">
        <v-flex xs12 style="padding-top:8px">
          <v-btn class="success searchbtn" @click="fetchstatement">Search</v-btn>
          <v-menu
            :close-on-content-click="false"
            v-model="menu2"
            lazy
            transition="scale-transition"
            offset-y
            style="float:right"
          >
            <input
              type="text"
              slot="activator"
              v-model="date2"
              readonly
              class="search"
              placeholder="To Date"
            />
            <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
          </v-menu>
          <v-menu
            :close-on-content-click="false"
            v-model="menu1"
            lazy
            transition="scale-transition"
            offset-y
            style="float:right"
          >
            <input
              type="text"
              slot="activator"
              v-model="date1"
              readonly
              class="search"
              placeholder="From Date"
            />
            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
          </v-menu>
          <!-- <input type="number" class="search" v-model="mobile" placeholder="Enter Number" /> -->
        </v-flex>
        <v-layout row wrap>
          <v-spacer></v-spacer>
        </v-layout>
      </v-layout>
    </v-card>
    <v-data-table :headers="headers" :items="statementlist" :search="search">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderid }}</td>
        <td>{{ props.item.serviceName }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.mobile }}</td>
        <td>{{ props.item.amount }}</td>
        <td>{{ props.item.tid }}</td>
        <td>
          <v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn>
        </td>
        <td>{{ new Date(parseInt(props.item.time)) | moment("DD-MM-YYYY")}}</td>
        <td>
          <v-btn @click="getsummary(props.item)" small color="primary">View</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewstatus" width="950">
      <div class="printer__container">
        <div class="printer" ref="print">
          <div class="printer__header">
            <img src="../assets/logo.png" class="printer__image" alt />
            <p class="printer__title">Transaction Receipt</p>
            <img src="../assets/bbps.png" class="printer__image" alt />
          </div>
          <h3 style="text-align:center">Thank you for transacting at ShiromaniSmart</h3>
          <table class="printer__table">
            <tr>
              <td>MERCHANT</td>
              <td>{{user.UserName}}</td>
            </tr>
            <tr>
              <td>OPERATOR</td>
              <td>{{summary.serviceName}}</td>
            </tr>
            <tr>
              <td>Service Number</td>
              <td>{{summary.servicenumber}}</td>
            </tr>
            <tr>
              <td>Date & Time</td>
              <td>{{ new Date(parseInt(summary.time)) | moment("DD-MM-YYYY")}}</td>
            </tr>
            <tr>
              <td>Order id</td>
              <td>{{summary.orderid}}</td>
            </tr>
            <tr>
              <td>Type</td>
              <td>{{summary.mobile}}</td>
            </tr>
            <tr>
              <td>Value (Rs)</td>
              <td>{{summary.amount}}</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>{{summary.status}}</td>
            </tr>
            <tr>
              <td>Reference ID</td>
              <td>{{summary.tid}}</td>
            </tr>
          </table>
        <h3 style="margin:10px 0px">Terms & Conditions / Disclaimer</h3>
        <p>1.Customer Convenience Fee(CCF)=Rs,0.00 inclusive of GST</br>
        2.This transaction receipt is only provisional acknowledgment and is issued to customer mentioned herein for accepting mentioned payment for the above order and as per the details provided by the customer
        </br>
        3.The customer is fully responsible for the accuracy of the details as provided by him before the transation is initiated
        </br>
        4.The Merchant shall not charge any fee to the customer directly for services rendered by them.
        </p>
        </div>
        <div class="printer__footer">
          <v-spacer />
          <v-btn color="red" dark @click="viewstatus = false">Cancel</v-btn>
          <v-btn color="primary" @click="print()">Print</v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      modal: false,
      date1: "",
      menu1: false,
      date2: "",
      menu2: false,
      mobile: "",
      headers: [
        { text: "Auto No", value: "orderno", align: "left" },
        { text: "Service Name", value: "name" },
        { text: "Name", value: "sender" },
        { text: "Mobile Number", value: "mobile" },
        { text: "Amount", value: "amount" },
        { text: "TransactionID", value: "transactionid" },
        { text: "Status", value: "status" },
        { text: "Recharge Time", value: "time" },
        { text: "Action", value: "action" }
      ],
      dialog: false,
      viewstatus: false,
      statementlist: [],
      modal: false,
      search: "",
      summary: {}
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    dmr() {
      return this.$store.getters.instapay;
    }
  },
  watch: {
    dmr(val) {
      console.log(val);
      if (val != null) {
        this.fetchstatement();
        this.mobile = val.mobile_no;
      }
    }
  },
  methods: {
    checkstatus(status) {
      status = status.toLowerCase();
      if (status == "success") return "success";
      if (status == "pending") return "grey";
      if (status == "inprocess") return "warning";
      if (status == "failed") return "error";
      return "primary";
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    pushstatement(value) {
      let vm = this;
      vm.statementlist = [];
      for (let i = 0; i < value.length; i++) {
        let doc = value[i];
        let servicenumber = "";
        try {
          if(doc.MobileNo) {
            let separated = doc.MobileNo.split("-");
            servicenumber = separated[1];
          }
        }catch(e) {

        }
        console.log(servicenumber)
        let time = doc.RechargeDate.replace("/Date(", "").replace(")/", "");
        vm.statementlist.push({
          orderid: doc.Id,
          serviceName:doc.ServiceName,
          name:vm.user.UserName,
          amount: doc.Amount,
          servicenumber,
          mobile: doc.ServiceType,
          time: time,
          tid: doc.TransactionId,
          status: doc.Status,
        });
      }
    },
    getsummary(doc) {
      let vm = this;
      vm.viewstatus = true;
      vm.summary = doc;
    },
    print() {
      let vm = this;
      const css = `
              @media print {
                body {-webkit-print-color-adjust: exact;}
              }
                .printer {
                  width:100%;
                  background:white;
                }
                .printer__header {
                  display:flex;
                  margin-bottom:20px;
                  justify-content: space-between;
                }
                .printer__image {
                  width: 100px;
                  height: 40px;
                  object-fit: contain;
                }
                .printer__title {
                  font-size: 2rem;
                  float: left;
                  margin:0px;
                  text-align: center;
                }
                .printer__table {
                  width: 100%;
                  margin-top:10px;
                  border-collapse: collapse;
                }
                .printer__table tr td{
                  border: 1px solid #3f51b5;
                  font-weight: bold;
                  text-transform: uppercase;
                }
                .printer__tr td{
                  font-size: 1.2em;
                }
                .printer__tr--title {
                  background:green;
                  font-weight:bold;
                  color:white;
                }
                .printer__table--border td {
                  border: 1px solid lightgrey;
                  margin-bottom: 10px;
                }`;
      const prtHtml = vm.$refs.print.innerHTML;
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <style>
                    ${css}
                    </style>
                </head>
                <body>
                    <div class="printer">
                        ${prtHtml}
                    </div>
                </body>
                </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function() {
        WinPrint.print();
        WinPrint.close();
      }, 500);
    },
    fetchstatement() {
      let vm = this;
      if (!vm.user.phone)
        return vm.notification("warn", "Authentication Required!");
      let mobile = vm.dmr != null ? vm.dmr.mobile_no : "";
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        recordcnt: "50",
        FromDate: vm.date1,
        Todate: vm.date2
      };
      vm.dialog = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "BBPS_Transaction_History",
          type: "aeps",
          data: doc
        })
        .then(function(res) {
          vm.dialog = false;
          vm.pushstatement(res.data);
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    }
  },
  mounted() {
    let vm = this;
    vm.fetchstatement();
  }
};
</script>


<style scoped>
.search {
  width: 150px;
  float: right;
  height: 34px;
  background: white;
  border: 1px solid lightgray;
  outline: none;
  margin-left: 20px;
  padding-left: 10px;
  font-size: 1em;
}
.searchbtn {
  margin-right: 15px;
  height: 34px;
  margin-left: 20px;
  float: right;
  margin-top: 0px;
}
.printer__container {
  background: white;
}
.printer {
  width: 100%;
  background: white;
  padding: 25px;
}
.printer__header {
  display:flex;
  justify-content: space-between;
}
.printer__image {
  width: 100px;
  height: 40px;
  float: left;
  object-fit: contain;
}
.printer__title {
  font-size: 2rem;
  float: left;
  text-align: center;
}
.printer__table {
  width: 100%;
  margin-top:10px;
  border-collapse: collapse;
}
.printer__table tr td{
  border: 1px solid #3f51b5;
  font-weight: bold;
  text-transform: uppercase;
}
.printer__tr td {
  padding: 10px !important;
  font-size: 1.2em;
}
.printer__tr--title {
  background: green;
  font-weight: bold;
  color: white;
}
.printer__table--border td {
  border: 1px solid lightgrey;
  margin-bottom: 10px;
}
.printer__footer {
  display: flex;
  padding-right: 15px;
  padding-bottom: 15px;
}
</style>

